import { DisplayValuesMap } from '~/common/types/data';
import {
  ApplicationNominationFlag,
  ApplicationOfferFlag,
} from '~/common/types/housingApplications';

export const applicationOfferFlagDisplayValues: DisplayValuesMap<ApplicationOfferFlag> = {
  N: 'Not under offer',
  O: 'Under offer',
  A: 'Accepted',
};

export const applicationNominationFlagDisplayValues: DisplayValuesMap<ApplicationNominationFlag> = {
  N: 'Not under nomination',
  O: 'Under nomination',
  A: 'Accepted',
};
